<div class="flex-container">
  <div nz-col nzSpan="6" class="page-content--left">
    <form class="filter-form" nz-form (ngSubmit)="search()">
      <div class="filter-form__header sticky">
        <button class="button float-left" nz-button nzType="secondary" type="button" (click)="setDefaultParams()">
          {{ 'pechkin.int-10.1.filter.reset' | translate }}
        </button>
        <button class="button float-right" nz-button nzType="primary" [disabled]="loading" type="submit">
          {{ 'pechkin.int-10.1.filter.search' | translate }}
        </button>
      </div>
      <div class="filter-form__body">
        <hw-panel-form-item class="date-picker-group" label="{{ 'pechkin.int-10.1.filter.date-from' | translate }}">
          <hw-date-time-picker name="date-lower" [(ngModel)]="params.dateFrom"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item class="date-picker-group" label="{{ 'pechkin.int-10.1.filter.date-to' | translate }}">
          <hw-date-time-picker name="date-upper" [(ngModel)]="params.dateTo"></hw-date-time-picker>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'pechkin.int-10.1.filter.type' | translate }}">
          <nz-select name="type" [(ngModel)]="params.type" [nzAllowClear]="true">
            <nz-option nzLabel="SMS" nzValue="SMS"></nz-option>
            <nz-option nzLabel="EMAIL" nzValue="EMAIL"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'pechkin.int-10.1.filter.status' | translate }}">
          <nz-select name="status" [(ngModel)]="params.status" [nzAllowClear]="true">
            <nz-option nzLabel="SENT" nzValue="SENT"></nz-option>
            <nz-option nzLabel="RECEIVED" nzValue="RECEIVED"></nz-option>
            <nz-option nzLabel="FAILED" nzValue="FAILED"></nz-option>
          </nz-select>
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'pechkin.int-10.1.filter.receiver' | translate }}">
          <input nz-input name="receiver" [(ngModel)]="params.receiver" />
        </hw-panel-form-item>
        <hw-panel-form-item label="{{ 'pechkin.int-10.1.filter.text' | translate }}">
          <input nz-input name="content" [(ngModel)]="params.content" />
        </hw-panel-form-item>
      </div>
    </form>
  </div>
  <nz-content class="page-content--header-inside">
    <hw-page-header header="integration.log-01.header" class="page-header"></hw-page-header>
    <div class="page-content__flex-cols-container">
      <hw-backend-table
        *ngIf="messageLogs"
        nz-col
        nzSpan="24"
        [query]="params"
        (dataChange)="getMessageLogs()"
        [result]="messageLogs"
        [loading]="loading">
        <hw-backend-column title="{{ 'pechkin.int-10.1.attributes.id' | translate }}">
          <ng-template #cellTemplate let-log>
            <a [routerLink]="['/message-logs/view', log.id]">{{ log.id }}</a>
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="{{ 'pechkin.int-10.1.attributes.date' | translate }}" sort="date">
          <ng-template #cellTemplate let-log>
            {{ log.date | localDateTime }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="{{ 'pechkin.int-10.1.attributes.type' | translate }}">
          <ng-template #cellTemplate let-log>
            {{ log.type }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="{{ 'pechkin.int-10.1.attributes.receiver' | translate }}">
          <ng-template #cellTemplate let-log>
            {{ log.receiver }}
          </ng-template>
        </hw-backend-column>
        <hw-backend-column title="{{ 'pechkin.int-10.1.attributes.status' | translate }}">
          <ng-template #cellTemplate let-log>
            {{ log.status }}
          </ng-template>
        </hw-backend-column>

        <hw-backend-column>
          <ng-template #cellTemplate let-log>
            <a *ngIf="log.canResend" (click)="resend(log)">{{ 'pechkin.int-10.1.attributes.resend' | translate }}</a>
          </ng-template>
        </hw-backend-column>
      </hw-backend-table>
    </div>
  </nz-content>
</div>
